import React from "react";
import CommonTable from "../../../components/tables/CommonTable";
import { Card } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import UsersSearchTable from "./UsersSearchTable";
import { UserCheck } from "react-feather";

const ActiveUsers = ({ activeUsers, mode, setLoading }) => {
  const columns = [
    {
      Header: "Name",
      accessor: "person.name",
      Cell: (cell) => (
        <React.Fragment>
          <UserCheck
            color="green"
            //  fill="green"
            strokeWidth={"2px"}
          />
          &nbsp;&nbsp;&nbsp;
          <NavLink
            to={{
              pathname: "/users/edit",
              search: `?id=${cell.row.original.user_id}`,
            }}
          >
            {cell.value}
          </NavLink>
        </React.Fragment>
      ),
    },
    {
      Header: "Profile",
      accessor: "permission.permission_name",

      Cell: ({ column, row, cell, value }) => {
        return (
          <>
            {row.original.person.role === "Admin" ? (
              <div>
                <i>(Administrator)</i>
              </div>
            ) : (
              <NavLink
                to={{
                  pathname: "/accessprofiles/edit",
                  search: `?id=${row.original["permission"]["_id"]}`,
                }}
              >
                {cell.value}
              </NavLink>
            )}
          </>
        );
      },
      disableFilters: true,
    },
  ];

  // {"pageIndex":0,"pageSize":100,"sortBy":[{"id":"user_session.last_seen","desc":true}],"filters":[{"id":"is_active","value":"═╬>1"}]}

  return (
    <React.Fragment>
      <Card className="p-0">
        {mode === "page" ? (
          <UsersSearchTable
            setLoading={setLoading}
            defaultSortBy={[{ id: "user_session.last_seen", desc: true }]}
            defaultFilter={[{ id: "is_active", value: "═╬>1" }]}
          />
        ) : (
          <CommonTable
            columns={columns}
            data={activeUsers}
            singlePage={mode !== "page"}
            type={mode === "page" ? "" : "dashboard"}
            sort={[{ id: "person.name", desc: false }]}
            emptyMessage="No Active Users"
          />
        )}
      </Card>
    </React.Fragment>
  );
};

export default ActiveUsers;
